import { EpiBlock } from '@api/types';
import { BlockEditorMenu } from '@components';
import { lazyBlocks } from '@components/blocks/lazyBlocks';
import { getContentType } from '@utils/content.utils';
import React, { Suspense } from 'react';

type BlockWrapperProperties = {
  wrapperComponent?: React.FC<any>;
  blockData?: EpiBlock;
  isEditMode?: boolean;
  enableContextMenu?: boolean;
  enableNativeOverlay?: boolean;
  disableEditPanel?: boolean;
  [key: string]: any;
};

export const BlockWrapper = (props: BlockWrapperProperties) => {
  const {
    blockData = {},
    wrapperComponent,
    enableContextMenu,
    disableEditPanel,
    enableNativeOverlay,
  } = props;

  const { contentLink = {} } = blockData;
  const block = contentLink?.expanded ? contentLink?.expanded : blockData;

  const types = block?.contentType;
  const type = getContentType(types);

  const LazyComponent = lazyBlocks[type];

  const children = LazyComponent ? (
    <Suspense fallback={null}>
      <LazyComponent key={contentLink.guidValue} {...block} disableEditPanel={disableEditPanel} />
    </Suspense>
  ) : null;

  return (
    <BlockEditorMenu
      id={contentLink.id}
      title={contentLink?.expanded?.name}
      enableContextMenu={enableContextMenu}
      enableNativeOverlay={enableNativeOverlay}
      block={block}
    >
      {wrapperComponent ? React.createElement(wrapperComponent, { children, block }) : children}
    </BlockEditorMenu>
  );
};
